const initialWebSocketState = {
    flag: false
}
const WebSocketBucket = (state = initialWebSocketState, action) => {
    switch(action.type){
        case "ADD_WEBSOCKET":
            return {
                ...state,
                flag: action.payload
            }
        default:
            return state
    }
}

export default WebSocketBucket;